let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hv7bx")).then(() => parcelRequire('4hiou'));